/* https://github.com/pmiatkowski/angularNgrx/blob/master/src/app/state/effects/currency.effects.ts */
import { Injectable } from '@angular/core';

@Injectable()
export class LoaderEffects {
    constructor() {}
}
